import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import React, { useState } from 'react';
import './App.css';
import ProgressState from './components/ProgressState';
import Results from './components/Results';
import Step from './components/Step';
import SurveyIntro from './components/SurveyIntro';
import { MaxQuizPoints, QuizQuestions } from './constants/QuizQuestions';
import { TextDomain } from './constants/TextDomain';
import { Option } from './types/Option';

const { __ } = window.wp.i18n;

function App() {
    const [questionHistory, setQuestionHistory] = useState<number[]>([]);
    const [activeQuestion, setActiveQuestion] = useState(-1);
    const [points, setPoints] = useState<number[]>([]);

    const [selectedOptionIndex, setSelectedOptionIndex] = useState<number | null>(null);

    const reset = () => {
        setQuestionHistory([]);
        setActiveQuestion(0);
        setPoints([]);
        setSelectedOptionIndex(null);

        window.scrollTo({ top: 0, behavior: 'auto' });
    };

    const navigateToNext = () => {
        if (selectedOptionIndex !== null) {
            const selectedOption = QuizQuestions[activeQuestion].options[selectedOptionIndex];

            setPoints([selectedOption.value.points, ...points]);
            setQuestionHistory([activeQuestion, ...questionHistory]);

            const nextQuestion = selectedOption.value.skipTo || activeQuestion + 1;
            setActiveQuestion(nextQuestion);
            setSelectedOptionIndex(null);

            window.scrollTo({ top: 0, behavior: 'auto' });

            if (nextQuestion === QuizQuestions.length) {
                trackViewResult();
            }
        }
    };

    const navigateToPrev = () => {
        if (questionHistory.length > 0) {
            setPoints(points.slice(1));
            const toQuestion = questionHistory[0];
            setActiveQuestion(toQuestion);
            setQuestionHistory(questionHistory.slice(1));
            setSelectedOptionIndex(null);

            window.scrollTo({ top: 0, behavior: 'auto' });
        }
    };

    const trackViewResult = () => {
        if (window.ga) {
            window.ga('set', 'page', document.location.pathname + '?result=true');
            window.ga('send', 'pageview');
        }
    };

    return (
        <div>
            {activeQuestion < 0 && (
                <Step
                    nextText={__('Start', TextDomain)}
                    onNextClick={() => reset()}
                    submitFullWidth
                    header={<h2 className="top-title">{__('Alcohol consumption test', TextDomain)}</h2>}>
                    <SurveyIntro />
                </Step>
            )}

            {activeQuestion >= 0 && activeQuestion < QuizQuestions.length && (
                <div>
                    <ProgressState value={activeQuestion + 1} total={QuizQuestions.length} />
                    <Step
                        showPrev={activeQuestion > 0}
                        prevText={__('Previous', TextDomain)}
                        onPrevClick={() => navigateToPrev()}
                        nextText={__(activeQuestion === QuizQuestions.length - 1 ? 'Show results' : 'Next', TextDomain)}
                        onNextClick={() => navigateToNext()}
                        submitFullWidth={activeQuestion === QuizQuestions.length - 1}
                        header={
                            <>
                                <h3 className="top-title">{__(QuizQuestions[activeQuestion].question, TextDomain)}</h3>
                                {QuizQuestions[activeQuestion].description && (
                                    <p className="text">({__(QuizQuestions[activeQuestion].description, TextDomain)})</p>
                                )}
                            </>
                        }>
                        <RadioGroup aria-label="quiz" name="quiz" value={selectedOptionIndex} onChange={(_, value) => setSelectedOptionIndex(+value)}>
                            {QuizQuestions[activeQuestion].options.map((option: Option, index: number) => (
                                <FormControlLabel value={index} control={<Radio />} label={__(option.label, TextDomain)} />
                            ))}
                        </RadioGroup>
                    </Step>
                </div>
            )}

            {activeQuestion === QuizQuestions.length && <Results points={points.reduce((acc, p) => acc + p, 0)} maxPoints={MaxQuizPoints} />}
        </div>
    );
}

export default App;
